import React from 'react';
import EarningsManagementContainer from '@src/containers/EarningsManagement';

const ReferralContainer = () => <EarningsManagementContainer />;

export default ReferralContainer;
